import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Organisation } from '../../../../models/organisation.model';
import { LoadingSpinnerComponent } from '@Components';
import { RouterLinkWithHref } from '@angular/router';
import { OrganisationsMappingService } from '@Services';
import { NgClass } from '@angular/common';
import { OrganisationFilterPipe } from '@Utils';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-org-mapping-list',
  standalone: true,
  imports: [LoadingSpinnerComponent, RouterLinkWithHref, NgClass, OrganisationFilterPipe, FormsModule],
  templateUrl: './org-mapping-list.component.html',
  styleUrl: './org-mapping-list.component.css',
})
export class OrgMappingListComponent implements OnInit {
  organisationsCount = 0;
  organisationsContentArray: Organisation[] = [];
  isLoading = false;

  orgCodeFilter = '';
  areaFilter = '';

  @ViewChild('pageTitle') pageTitle!: ElementRef<HTMLHeadingElement>;

  alertType: 'success' | 'danger' | 'info' = 'info';

  isAlertVisible = false;
  alertMessage = '';

  constructor(private _adminService: OrganisationsMappingService) {}

  clearFilters(): void {
    this.orgCodeFilter = '';
    this.areaFilter = '';
  }

  get hasActiveFilters(): boolean {
    return !!this.orgCodeFilter.trim() || !!this.areaFilter.trim();
  }

  ngOnInit() {
    this.loadOrganisations();
  }

  loadOrganisations() {
    this.isLoading = true;
    this._adminService.getAllOrganisations().subscribe({
      next: (response) => {
        this.organisationsCount = response.length;
        this.isLoading = false;
        this.organisationsContentArray = response;
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      },
    });
  }

  onDeleteOrg(guid: string) {
    this._adminService.deleteOrganisation(guid).subscribe({
      next: () => {
        this.focusTitle();
        this.showAlert('Organisation deleted successfully');
        this.loadOrganisations();
      },
      error: (err) => {
        console.error('Failed to delete item', err);
      },
    });
  }

  showAlert(message: string, type: 'success' | 'danger' | 'info' = 'info') {
    this.alertMessage = message.trim();
    this.alertType = type;
    this.isAlertVisible = true;

    // Hide the alert after 8 seconds
    setTimeout(() => {
      this.isAlertVisible = false;
    }, 8000);
  }

  dismissAlert(): void {
    this.isAlertVisible = false;
    this.alertMessage = '';
  }

  focusTitle() {
    if (this.pageTitle) {
      this.pageTitle.nativeElement.focus();
      requestAnimationFrame(() => {
        this.pageTitle.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
}
